'use strict';
$('body').on('search-analytics-trigger', function (e) {
    searchListener(e);
});
$(document).ready(function (e) {
    editorialListener();
});
$('body').on('click', '.js-analytics-click', function (e) {
    const el = this;
    if (!el) return;
    const dataEvent = el.dataset.event || null;
    const eventName = el.dataset.eventName || '';
    const eventType = el.dataset.eventType || 'click';
    const extraEventName = el.dataset.extraEventName || '';
    const itemListName = el.dataset.itemListName || '';

    const product = getProductData(el);

    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
        event: dataEvent || eventName,

        environment: getEnvironmentAnalytics(eventName, eventType, extraEventName),

        user: getUserAnalytics(),

        ecommerce: getProductListAnalytics(itemListName, product)

    });
});

function getEnvironmentAnalytics (eventName, eventType, extraEventName) {
    if (window.dataLayer && window.dataLayer.length) {
        const existing = window.dataLayer.find(d => d.environment);
        if (existing) {
            existing.environment.event_name = eventName || '';
            existing.environment.event_type = eventType || '';
            existing.environment.extra_event_name = extraEventName || '';
        }
        return existing.environment;
    }
    return {
        environment_name: '',
        environment_version: '',
        product_catalog: '',
        site_domain: '',
        site_name: '',
        site_country: '',
        site_language: '',
        event_type: eventType,
        event_name: eventName,
        extra_event_name: extraEventName
    };
}

function getUserAnalytics () {
    if (window.dataLayer && window.dataLayer.length) {
        const existing = window.dataLayer.find(d => d.user);
        if (existing) return existing.user;
    }

    return {};
}

function getProductListAnalytics (itemListName, product) {
    if (window.dataLayer && window.dataLayer.length) {
        const existing = window.dataLayer.find(d => d.ecommerce);

        if (existing) {
            const productLists = { ...existing.ecommerce };
            productLists.item_list_name = itemListName || productLists.item_list_name || '';
            productLists.items = existing.ecommerce.items || [];
            if (itemListName === 'checkout') {
                const submitButton = document.querySelector('.cc-checkout__cardshipment--selected');
                if (submitButton) {
                    productLists.shipping_method = submitButton.dataset.value || '';
                    productLists.shipping_amount_ati = parseFloat(submitButton.dataset.shippingAmountAti.replace('€', '').replace(',', '.'));
                    productLists.shipping_method = submitButton.dataset.shippingMethodName || '';
                }
            }

            if (product) {
                productLists.items = [product];
            }

            return productLists;
        }
    }

    if (!product) return null;

    return {
        item_list_name: itemListName,
        items: [product]
    };
}

function getProductData (el) {
    if (!el.dataset.pid) return null;

    if (window.dataLayer && window.dataLayer.length) {
        const existing = window.dataLayer.find(d => d.ecommerce);

        if (existing && existing.ecommerce.items && existing.ecommerce.items.length) {
            var matchedItem = existing.ecommerce.items.find(item =>
                item.item_id === el.dataset.pid
            );
            if (matchedItem) {
                const item = { ...matchedItem };
                item.quantity = $('.js-qtyLabel').val() || 1;
                return item;
            }
        }
        if (!matchedItem) {
            const salesPrice = parseFloat(el.dataset.price) || 0;
            const listPrice = parseFloat(el.dataset.priceList) || 0;
            const discount = listPrice > salesPrice ? parseFloat((listPrice - salesPrice).toFixed(2)) : '';
            const discountRate = el.dataset.discountPercentage || '';

            const toArray = (val) => val ? val.split(',').filter(Boolean) : [];
            const toStr = (val) => val || '';

            return {
                item_id: toStr(el.dataset.pid),
                item_ean: toStr(el.dataset.itemEan),
                item_name: toStr(el.dataset.productName),
                item_brand: toStr(el.dataset.itemBrand),
                item_category: toStr(el.dataset.itemCategory) || '',
                item_category_id: toStr(el.dataset.itemCategoryId) || '',
                item_category2: toStr(el.dataset.itemCategory2) || '',
                item_category2_id: toStr(el.dataset.itemCategory2Id) || '',
                item_category3: toStr(el.dataset.itemCategory3) || '',
                item_category3_id: toStr(el.dataset.itemCategory3Id) || '',
                item_category4: toStr(el.dataset.itemCategory4) || '',
                item_category4_id: toStr(el.dataset.itemCategory4Id) || '',
                item_category5: toStr(el.dataset.itemCategory5) || '',
                item_category5_id: toStr(el.dataset.itemCategory5Id) || '',
                item_customer_rating: toStr(el.dataset.rating),
                item_customer_reviews: '',
                item_is_bundle: parseInt(el.dataset.itemIsBundle) || 0,
                item_is_discounted: parseInt(el.dataset.itemIsDiscounted) || 0,
                item_is_instock: parseInt(el.dataset.itemIsInstock) || 0,
                item_is_insubscription: '',
                item_is_pro: false,
                item_asset_displayed: toStr(el.dataset.itemAsset),
                location_id: 'store',
                currency: toStr(el.dataset.currency),
                price: salesPrice,
                item_price_tf: salesPrice,
                discount: discount,
                item_discount_tf: discount,
                item_discount_rate: discountRate,
                item_list_id: toStr(el.dataset.itemListId),
                item_list_name: toStr(el.dataset.itemListName),
                promotion_id: '',
                promotion_name: '',
                is_regular_delivery: 0,
                regular_delivery_period: '',
                regular_delivery_discount_rate: '',
                index: parseInt(el.dataset.index) || 0,
                item_variant: toStr(el.dataset.itemVariant),
                expert_rating: '',
                cafe_variety: toArray(el.dataset.cafeVariety),
                cafe_designation: '',
                cafe_roasting_country: toStr(el.dataset.cafeRoastingCountry),
                cafe_roasting_type: toStr(el.dataset.cafeRoastingType),
                cafe_roasting_type_level: '',
                cafe_roasting_maxicoffee: toArray(el.dataset.cafeRoastingMaxicoffee),
                cafe_aromatic_group: '',
                cafe_aromatic_note_primary: toStr(el.dataset.cafeNotePrimary),
                cafe_aromatic_note_secondary: toStr(el.dataset.cafeNoteSecondary),
                cafe_aromatic_tasting_notes: toStr(el.dataset.cafeTastingNotes),
                cafe_packaging: [],
                coupon: '',
                quantity: 1,
                affiliation: 'ecommerce'
            };
        }
    }
}

function searchListener () {
    const elements = document.querySelectorAll('.js-analytics-search');

    if (!elements.length) return;

    const items = [];
    let itemListName = '';
    let eventName = '';
    let extraEventName = '';

    for (let i = 0; i < elements.length; i++) {
        const dataset = elements[i].dataset;

        itemListName = dataset.itemListName || itemListName;
        eventName = dataset.eventName || eventName;
        extraEventName = dataset.extraEventName || extraEventName;

        items.push(buildProductItem(dataset, i));
    }

    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
        event: eventName,
        environment: getEnvironmentAnalytics(eventName, 'impression', extraEventName),
        user: getUserAnalytics(),
        search: getSearchAnalytics(),
        ecommerce: {
            item_list_name: itemListName,
            items: items
        },

    });
}

function getSearchAnalytics () {
    var searchTerms = $('#siteSearch').val() || '';

    if (window.dataLayer && window.dataLayer.length) {
        const existing = window.dataLayer.find(d => d.search_engine);
        if (existing) return existing.search_engine;
    }

    return {
        search_id: '',
        search_term: searchTerms,
        store_id: '',
        origin: '',
        numberResult: '',
        filter: {
            drinks: ''
        }
    };
}

// add this class: 'js-analytics-editorial' on  editorial element to trigger analytics on editorial pages, add also exstra_even_name on the template
function editorialListener () {
    const elements = document.querySelectorAll('.js-analytics-editorial');

    if (!elements.length) return;

    const items = [];
    let itemListName = '';
    let eventName = '';
    let extraEventName = '';
    elements.forEach((el, index) => {
        const dataset = el.dataset;
        dataset.itemListName = '';
        dataset.eventName = '';
        dataset.extraEventName = '';

        items.push(buildProductItem(dataset, index));
    });

    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
        environment: getEnvironmentAnalytics(eventName, 'impression', extraEventName),
        user: getUserAnalytics(),
        ecommerce: {
            item_list_name: itemListName,
            items: items
        }
    });
}
function buildProductItem (dataset, index) {
    return {
        item_id: dataset.pid || '',
        item_ean: dataset.ean || '',
        item_name: dataset.productName || '',
        item_brand: dataset.brand || '',

        item_category: dataset.itemCategory || '',
        item_category_id: dataset.itemCategoryId || '',
        item_category2: dataset.itemCategory2 || '',
        item_category2_id: dataset.itemCategory2Id || '',
        item_category3: dataset.itemCategory3 || '',
        item_category3_id: dataset.itemCategory3Id || '',
        item_category4: dataset.itemCategory4 || '',
        item_category4_id: dataset.itemCategory4Id || '',
        item_category5: dataset.itemCategory5 || '',
        item_category5_id: dataset.itemCategory5Id || '',

        item_customer_rating: dataset.customerRating || '',
        item_customer_reviews: dataset.customerReviews || '',

        item_is_bundle: dataset.isBundle || '',
        item_is_discounted: dataset.isDiscounted || '',
        item_is_instock: dataset.isInStock || '',
        item_is_insubscription: dataset.isSubscription || '',
        item_is_pro: dataset.isPro || '',

        item_asset_displayed: dataset.assetDisplayed || '',
        location_id: dataset.locationId || '',

        currency: dataset.currency || '',
        price: dataset.price || '',
        item_price_tf: dataset.priceTf || '',

        discount: dataset.discount || '',
        item_discount_tf: dataset.discountTf || '',
        item_discount_rate: dataset.discountRate || '',

        item_list_id: dataset.itemListId || '',
        item_list_name: dataset.itemListName || '',

        promotion_id: dataset.promotionId || '',
        promotion_name: dataset.promotionName || '',

        is_regular_delivery: dataset.isRegularDelivery || '',
        regular_delivery_period: dataset.regularDeliveryPeriod || '',
        regular_delivery_discount: dataset.regularDeliveryDiscount || '',
        regular_delivery_discount_rate: dataset.regularDeliveryDiscountRate || '',

        index: dataset.listItem || index,
        item_variant: dataset.variant || '',

        expert_rating: dataset.expertRating || '',

        cafe_variety: dataset.cafeVariety || '',
        cafe_designation: dataset.cafeDesignation || '',
        cafe_roasting_country: dataset.cafeRoastingCountry || '',
        cafe_roasting_type: dataset.cafeRoastingType || '',
        cafe_roasting_type_level: dataset.cafeRoastingLevel || '',
        cafe_roasting_maxicoffee: dataset.cafeRoastingMaxicoffee || '',

        cafe_aromatic_group: dataset.cafeAromaticGroup || '',
        cafe_aromatic_note_primary: dataset.cafeAromaticPrimary || '',
        cafe_aromatic_note_secondary: dataset.cafeAromaticSecondary || '',
        cafe_aromatic_tasting_notes: dataset.cafeAromaticNotes || '',

        cafe_packaging: dataset.cafePackaging || '',

        coupon: dataset.coupon || '',
        quantity: dataset.quantity || 1,
        affiliation: dataset.affiliation || ''
    };
}
